<div class="main space-between-horizontal-centered">
  <div class="start-row-container row-gap-1p25">
    <div class="org-logo-wrapper">
      <img class="org-logo" [src]="organization.logo" alt="organization logo" #logo
        (error)="logo.src=errorImageLink">
    </div>
    <div class="start-start-row-container">
      <div *ngIf="organization.name" class="start-column-container width-15 column-gap-0p25">
        <span class="font-4 bold500 opacity0p64">Organization</span>
        <span class="font-3">{{organization.name}}</span>
      </div>
      <div *ngIf="organization.organizationId" class="start-column-container width-10 column-gap-0p25">
        <span class="font-4 bold500 opacity0p64">ID</span>
        <span class="font-3">{{organization.organizationId}}</span>
      </div>
      <div *ngIf="organization.address" class="start-column-container width-10 column-gap-0p25">
        <span class="font-4 bold500 opacity0p64 ">Headquarters address</span>
        <span data-qa="org-address-link" class="font-3 sub-label green-link bold" (click)="openAddressInGoogleMaps()">{{organization.address}}</span>
      </div>
    </div>
  </div>
  <div class="start-row-container row-gap-0p5">
    <app-button 
      *ngIf="organization.webSiteLink"
      data-qa="website-button"
      [size]="'small'"
      [type]="'grey'"
      [iconName]="'planet.svg'"
      (buttonClick)="goToOrgWebSite()">Website
    </app-button>
    <app-button 
      *ngIf="isAdmin && (orgAccess.isOrganizationAdmin || orgAccess.isSuperAdmin)"
      data-qa="edit-org-info-button"
      [size]="'small'"
      [type]="'grey'"
      [iconName]="'edit.svg'"
      (buttonClick)="editOrg.emit(organization)">Edit
    </app-button>
  </div>
</div>